export default __webpack_public_path__ + "stumbler-screens_mobile@2x.3ba919cb.png";